/**
 * Depuración del polling de **receipts** (post-envío: `eth_getTransactionReceipt`).
 *
 * Activar **sin rebuild** (consola del navegador):
 *   localStorage.setItem('DEBUG_TX_RECEIPT', '1')
 *   → recargar (también vale `'true'`).
 *
 * Activar **por build** (`.env`):
 *   VITE_DEBUG_TX_RECEIPT=true
 *
 * Compatibilidad temporal (misma semántica): `DEBUG_TX_UPDATER`, `VITE_DEBUG_TX_UPDATER`.
 *
 * Guía canónica: `docs/500-guias/logs-debug-y-flags.md`.
 */

import { localStorageDebugOn, viteEnvDebugTrue } from './debugActivation'

const LS_PRIMARY = 'DEBUG_TX_RECEIPT'
const LS_LEGACY = 'DEBUG_TX_UPDATER'

const LOG_PREFIX = '[TX_RECEIPT]'

function stamp(): string {
  return new Date().toISOString()
}

export function isTxReceiptDebugEnabled(): boolean {
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_TX_RECEIPT)) return true
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_TX_UPDATER)) return true
  if (typeof window === 'undefined') return false
  try {
    if (localStorageDebugOn(window.localStorage?.getItem(LS_PRIMARY))) return true
    if (localStorageDebugOn(window.localStorage?.getItem(LS_LEGACY))) return true
  } catch {
    /* sin localStorage */
  }
  return false
}

export function txReceiptDebug(...args: unknown[]): void {
  if (!isTxReceiptDebugEnabled()) return
  // eslint-disable-next-line no-console
  console.log(LOG_PREFIX, stamp(), ...args)
}

export function txReceiptWarn(...args: unknown[]): void {
  if (!isTxReceiptDebugEnabled()) return
  // eslint-disable-next-line no-console
  console.warn(LOG_PREFIX, stamp(), ...args)
}
